
import React, { createContext, useContext } from "react";
import type { DataContextType } from "./DataContext.types";

// Context creation
export const DataContext = createContext<DataContextType | undefined>(undefined);

// Hook to use the context
export const useData = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error("useData must be used within a DataProvider");
  }
  console.log("useData - Context data:", {
    screens: context.screens.length,
    ads: context.ads.length,
    sales: context.sales.length,
  });
  return context;
};

// Re-export types if needed
export type { DataContextType };
